// tslint:disable
/* MACLE TypeScript 23/01/2026 00:31:29 */
import { BaseData, BaseDataDisplay, EFilterBool, EGenero, EFaixaEtaria, ETipoFrete, ESexo, DataEndereco, EStatusPedidoSite, EArredondPrc } from './maf.vo';
import { ArrayList } from 'maf-web';

export class PKContaAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.PKContaAPP";
  codEmpresa: number = 0;
  codConta: number = 0;

  constructor()
  constructor(codEmpresa: number, codConta: number)
  constructor(codEmpresa?: number, codConta?: number) {
    super();
    this.codEmpresa = codEmpresa || 0;
    this.codConta = codConta || 0;
  }

  public getPK(): PKContaAPP {
    return new PKContaAPP(this.codEmpresa, this.codConta);
  }

  public equals(arg: PKContaAPP): boolean {
    return arg 
        && (arg.codEmpresa === this.codEmpresa)
        && (arg.codConta === this.codConta)
    ;
  }
}


export class DataContaAPP extends PKContaAPP {
  readonly jclass: string = "com.macle.app.vo.DataContaAPP";
  codLoja: number = 0;
  descricao: string = "";
  idSeller: string = "";
}


export class DataEnderecoAuxML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataEnderecoAuxML";
  name: string = "";
  id: string = "";
}


export class DataEnderecoML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataEnderecoML";
  state: DataEnderecoAuxML = new DataEnderecoAuxML();
  country: DataEnderecoAuxML = new DataEnderecoAuxML();
  comment: string = "";
  city: DataEnderecoAuxML = new DataEnderecoAuxML();
  street_name: string = "";
  receiver_name: string = "";
  street_number: string = "";
  neighborhood: DataEnderecoAuxML = new DataEnderecoAuxML();
  zip_code: string = "";
}


export class DataPedidoClienteDocumentoML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoClienteDocumentoML";
  value: string = "";
  id: string = "";
}


export class DataPedidoClienteDocumentoAdicionalML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoClienteDocumentoAdicionalML";
  value: string = "";
  type: string = "";
}


export class DataPedidoClienteReceiverML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoClienteReceiverML";
  name: string = "";
  id: number = 0;
  billing_address: DataEnderecoML = new DataEnderecoML();
  city_ibge: string = "";
  document: DataPedidoClienteDocumentoML = new DataPedidoClienteDocumentoML();
  additional_documents: ArrayList<DataPedidoClienteDocumentoAdicionalML> = new ArrayList<DataPedidoClienteDocumentoAdicionalML>(DataPedidoClienteDocumentoAdicionalML);
}


export class DataPedidoClienteML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoClienteML";
  receiver: DataPedidoClienteReceiverML = new DataPedidoClienteReceiverML();
}


export enum EFormaPagamentoAPP {
  NONE = 0,
  BOLETO = 1,
  CARTAO = 2,
  CREDIARIO = 3,
  CONDICIONAL = 4,
  PIX = 5,
  MARKETPLACE = 6,
}

export namespace EFormaPagamentoAPP {
  export function toDisplay(arg: EFormaPagamentoAPP): string {
    switch (arg) {
      case 0: return "";
      case 1: return "Boleto";
      case 2: return "Cart&atilde;o";
      case 3: return "Credi&aacute;rio";
      case 4: return "Condicional";
      case 5: return "PIX";
      case 6: return "Marketplace";
      default: return "";
    }
  }

  export function enums(): EFormaPagamentoAPP[] {
    return [EFormaPagamentoAPP.NONE,EFormaPagamentoAPP.BOLETO,EFormaPagamentoAPP.CARTAO,EFormaPagamentoAPP.CREDIARIO,EFormaPagamentoAPP.CONDICIONAL,EFormaPagamentoAPP.PIX,EFormaPagamentoAPP.MARKETPLACE];
  }
}


export class FilterPedidoVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.FilterPedidoVit";
  cnpj: string = "";
  dataIni: string = "";
  dataFim: string = "";
  enviadoSistema: EFilterBool = EFilterBool.NONE;
}


export enum ETipoFreteAPP {
  NONE = 0,
  SEDEX = 1,
  PAC = 2,
  ENVIO_FLEX_ML = 3,
}

export namespace ETipoFreteAPP {
  export function toDisplay(arg: ETipoFreteAPP): string {
    switch (arg) {
      case 0: return "";
      case 1: return "Sedex";
      case 2: return "PAC";
      case 3: return "Envio Flex";
      default: return "";
    }
  }

  export function enums(): ETipoFreteAPP[] {
    return [ETipoFreteAPP.NONE,ETipoFreteAPP.SEDEX,ETipoFreteAPP.PAC,ETipoFreteAPP.ENVIO_FLEX_ML];
  }
}


export class DataFreteAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataFreteAPP";
  prazoEntrega: string = "";
  tipoFrete: ETipoFreteAPP = ETipoFreteAPP.NONE;
  indisponivel: boolean = false;
  valorFrete: number = 0;
}


export class DataFreteVitrinePubAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataFreteVitrinePubAPP";
  codClienteMacle: number = 0;
  nomeLoja: string = "";
  frete: ArrayList<DataFreteAPP> = new ArrayList<DataFreteAPP>(DataFreteAPP);
}


export class DataPedidoCompradorML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoCompradorML";
  id: number = 0;
  nickname: string = "";
}


export class DataPedidoEntregaLimiteEnvioML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoEntregaLimiteEnvioML";
  date: string = "";
}


export class DataPedidoEntregaOpcaoEnvioML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoEntregaOpcaoEnvioML";
  estimated_delivery_limit: DataPedidoEntregaLimiteEnvioML = new DataPedidoEntregaLimiteEnvioML();
}


export class DataPedidoEntregaML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoEntregaML";
  base_cost: number = 0;
  tracking_number: string = "";
  receiver_id: number = 0;
  sender_id: number = 0;
  tracking_method: string = "";
  shipping_option: DataPedidoEntregaOpcaoEnvioML = new DataPedidoEntregaOpcaoEnvioML();
  logistic_type: string = "";
  receiver_address: DataEnderecoML = new DataEnderecoML();
}


export class DataPedidoMediadorML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoMediadorML";
  id: number = 0;
}


export class DataPedidoPagamentoML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoPagamentoML";
  id: number = 0;
  status: any;
  reason: string = "";
  transaction_amount_refunded: number = 0;
  installments: number = 0;
  payer_id: number = 0;
  order_id: number = 0;
  date_created: string = "";
  payment_method_id: string = "";
  transaction_amount: number = 0;
  total_paid_amount: number = 0;
}


export class DataPedidoShippingML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoShippingML";
  id: number = 0;
}


export class DataPedidoItemVariacaoML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoItemVariacaoML";
  name: string = "";
  id: string = "";
  value_id: string = "";
  value_name: string = "";
}


export class DataPedidoItemDadosML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoItemDadosML";
  id: string = "";
  title: string = "";
  variation_id: number = 0;
  warranty: string = "";
  seller_sku: string = "";
  category_id: string = "";
  variation_attributes: ArrayList<DataPedidoItemVariacaoML> = new ArrayList<DataPedidoItemVariacaoML>(DataPedidoItemVariacaoML);
}


export class DataPedidoItemML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoItemML";
  item: DataPedidoItemDadosML = new DataPedidoItemDadosML();
  sale_fee: number = 0;
  full_unit_price: number = 0;
  unit_price: number = 0;
  quantity: number = 0;
  listing_type_id: string = "";
}


export class DataPedidoResultML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoResultML";
  id: number = 0;
  cliente: DataPedidoClienteML = new DataPedidoClienteML();
  status: any;
  buyer: DataPedidoCompradorML = new DataPedidoCompradorML();
  entrega: DataPedidoEntregaML = new DataPedidoEntregaML();
  pack_id: number = 0;
  seller: DataPedidoCompradorML = new DataPedidoCompradorML();
  expiration_date: string = "";
  date_closed: string = "";
  paid_amount: number = 0;
  mediations: ArrayList<DataPedidoMediadorML> = new ArrayList<DataPedidoMediadorML>(DataPedidoMediadorML);
  payments: ArrayList<DataPedidoPagamentoML> = new ArrayList<DataPedidoPagamentoML>(DataPedidoPagamentoML);
  shipping: DataPedidoShippingML = new DataPedidoShippingML();
  order_items: ArrayList<DataPedidoItemML> = new ArrayList<DataPedidoItemML>(DataPedidoItemML);
  total_amount: number = 0;
  date_created: string = "";
  last_updated: string = "";
  date_last_updated: string = "";
}


export class DataPedidoPaginacaoML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoPaginacaoML";
  offset: number = 0;
  limit: number = 0;
  total: number = 0;
}


export class DataPedidoML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoML";
  query: string = "";
  display: string = "";
  results: ArrayList<DataPedidoResultML> = new ArrayList<DataPedidoResultML>(DataPedidoResultML);
  paging: DataPedidoPaginacaoML = new DataPedidoPaginacaoML();
}


export class LVPedStatsBrowser extends BaseData {
  readonly jclass: string = "com.macle.site.vo.LVPedStatsBrowser";
  browser: string = "";
  versaoBrowser: string = "";
  browserType: string = "";
}


export enum ETipoConfirmacaoConsumidorSiteAPP {
  NONE = 0,
  SMS = 1,
  EMAIL = 2,
}

export namespace ETipoConfirmacaoConsumidorSiteAPP {
  export function toDisplay(arg: ETipoConfirmacaoConsumidorSiteAPP): string {
    switch (arg) {
      case 0: return "Nenhum";
      case 1: return "SMS";
      case 2: return "EMAIL";
      default: return "";
    }
  }

  export function enums(): ETipoConfirmacaoConsumidorSiteAPP[] {
    return [ETipoConfirmacaoConsumidorSiteAPP.NONE,ETipoConfirmacaoConsumidorSiteAPP.SMS,ETipoConfirmacaoConsumidorSiteAPP.EMAIL];
  }
}


export class LVPKPedido extends BaseData {
  readonly jclass: string = "com.macle.site.vo.LVPKPedido";
  codPedido: number = 0;

  constructor()
  constructor(codPedido: number)
  constructor(codPedido?: number) {
    super();
    this.codPedido = codPedido || 0;
  }

  public getPK(): LVPKPedido {
    return new LVPKPedido(this.codPedido);
  }

  public equals(arg: LVPKPedido): boolean {
    return arg 
        && (arg.codPedido === this.codPedido)
    ;
  }
}


export enum EStatusPedido {
  NONE = 0,
  PRECONFPAGTO = 7,
  CONFERENCIAPAGTO = 1,
  EMANALISE = 10,
  APROVADO = 6,
  REPROVADO = 8,
  EXPEDICAO = 2,
  EMBARQUE = 3,
  ENTREGUE = 4,
  CANCELADO = 5,
  DEVOLUCAO = 9,
  CONTESTADO = 11,
  NAOFINALIZADO = 12,
}

export namespace EStatusPedido {
  export function toDisplay(arg: EStatusPedido): string {
    switch (arg) {
      case 0: return "";
      case 7: return "";
      case 1: return "Confirma&amp;ccedil;&amp;atilde;o de pagamento";
      case 10: return "Pedido em an&amp;aacute;lise";
      case 6: return "Pedido aprovado";
      case 8: return "Pedido reprovado";
      case 2: return "Preparado para envio";
      case 3: return "Pedido em transporte";
      case 4: return "Pedido entregue";
      case 5: return "Pedido cancelado";
      case 9: return "Pedido devolvido";
      case 11: return "Contestado";
      case 12: return "Pedido nao Finalizado";
      default: return "";
    }
  }

  export function enums(): EStatusPedido[] {
    return [EStatusPedido.NONE,EStatusPedido.PRECONFPAGTO,EStatusPedido.CONFERENCIAPAGTO,EStatusPedido.EMANALISE,EStatusPedido.APROVADO,EStatusPedido.REPROVADO,EStatusPedido.EXPEDICAO,EStatusPedido.EMBARQUE,EStatusPedido.ENTREGUE,EStatusPedido.CANCELADO,EStatusPedido.DEVOLUCAO,EStatusPedido.CONTESTADO,EStatusPedido.NAOFINALIZADO];
  }
}


export class LVPKVendedor extends BaseData {
  readonly jclass: string = "com.macle.site.vo.LVPKVendedor";
  codEmpresa: number = 0;
  codFuncionario: number = 0;

  constructor()
  constructor(codEmpresa: number, codFuncionario: number)
  constructor(codEmpresa?: number, codFuncionario?: number) {
    super();
    this.codEmpresa = codEmpresa || 0;
    this.codFuncionario = codFuncionario || 0;
  }

  public getPK(): LVPKVendedor {
    return new LVPKVendedor(this.codEmpresa, this.codFuncionario);
  }

  public equals(arg: LVPKVendedor): boolean {
    return arg 
        && (arg.codEmpresa === this.codEmpresa)
        && (arg.codFuncionario === this.codFuncionario)
    ;
  }
}


export enum ETipoPagto {
  NONE = 0,
  PAGSYS = 1,
  PAGSEGURO = 2,
  CIELO = 3,
  ITAU = 4,
  REDECARD = 5,
}

export namespace ETipoPagto {
  export function toDisplay(arg: ETipoPagto): string {
    switch (arg) {
      case 0: return "";
      case 1: return "Pagsys";
      case 2: return "Pag Seguro";
      case 3: return "Cielo";
      case 4: return "Itau";
      case 5: return "Redecard";
      default: return "";
    }
  }

  export function enums(): ETipoPagto[] {
    return [ETipoPagto.NONE,ETipoPagto.PAGSYS,ETipoPagto.PAGSEGURO,ETipoPagto.CIELO,ETipoPagto.ITAU,ETipoPagto.REDECARD];
  }
}


export enum EFormaPagto {
  NONE = 0,
  VISA = 1,
  MASTERCAR = 2,
  DINNERS = 3,
  AMERICANEXPRESS = 4,
  HIPERCARD = 5,
  BANCO_BRADESCO = 6,
  BANCO_BRASIL = 7,
  BANCO_ITAU = 8,
  BOLETO = 9,
  AMERICANEXPRESS_PAGSEGURO = 10,
  HIPERCARD_PAGSEGURO = 11,
  ITAU_PAGSEGURO = 12,
  BRADESCO_PAGSEGURO = 13,
  UNIBANCO_PAGSEGURO = 14,
  BANCOREAL_PAGSEGURO = 15,
  AURA_PAGSEGURO = 16,
  BANCOBRASIL_PAGSEGURO = 17,
  ELO = 18,
}

export namespace EFormaPagto {
  export function toDisplay(arg: EFormaPagto): string {
    switch (arg) {
      case 0: return "";
      case 1: return "Cart&amp;atilde;o Visa";
      case 2: return "Cart&amp;atilde;o MasterCard";
      case 3: return "Cart&amp;atilde;o Dinners";
      case 4: return "Cart&amp;atilde;o American Express";
      case 5: return "Cart&amp;atilde;o Hipercard";
      case 6: return "Banco Bradesco";
      case 7: return "Banco do Brasil";
      case 8: return "Banco Ita&amp;uacute;";
      case 9: return "Boleto";
      case 10: return "American Express - Pag Seguro";
      case 11: return "Hipercard - Pag Seguro";
      case 12: return "Ita&amp;uacute; - Pag Seguro";
      case 13: return "Bradesco - Pag Seguro";
      case 14: return "Unibanco - Pag Seguro";
      case 15: return "Banco Real - Pag Seguro";
      case 16: return "Aura - Pag Seguro";
      case 17: return "Banco do Brasil - Pag Seguro";
      case 18: return "Elo";
      default: return "";
    }
  }

  export function enums(): EFormaPagto[] {
    return [EFormaPagto.NONE,EFormaPagto.VISA,EFormaPagto.MASTERCAR,EFormaPagto.DINNERS,EFormaPagto.AMERICANEXPRESS,EFormaPagto.HIPERCARD,EFormaPagto.BANCO_BRADESCO,EFormaPagto.BANCO_BRASIL,EFormaPagto.BANCO_ITAU,EFormaPagto.BOLETO,EFormaPagto.AMERICANEXPRESS_PAGSEGURO,EFormaPagto.HIPERCARD_PAGSEGURO,EFormaPagto.ITAU_PAGSEGURO,EFormaPagto.BRADESCO_PAGSEGURO,EFormaPagto.UNIBANCO_PAGSEGURO,EFormaPagto.BANCOREAL_PAGSEGURO,EFormaPagto.AURA_PAGSEGURO,EFormaPagto.BANCOBRASIL_PAGSEGURO,EFormaPagto.ELO];
  }
}


export class LVDataTransacaoCieloResult extends BaseData {
  readonly jclass: string = "com.macle.site.vo.LVDataTransacaoCieloResult";
  tidTransacao: string = "";
  statusTransacao: number = 0;
  horaTransacao: string = "";
  panTransacao: string = "";
  arpAutorisacao: string = "";
  nsuAutorisacao: string = "";
  mensagemCaptura: string = "";
  dataTransacao: string = "";
  lrAutorisacao: string = "";
  valorTransacao: number = 0;
  codigoCaptura: number = 0;
  parcelasFormaPagto: number = 0;
  produtoFormaPagto: string = "";
  mensagemAutorisacao: string = "";
  codPedidoTransacao: number = 0;
  statusAutorizacao: number = 0;
  bandeiraTransacao: EFormaPagto = EFormaPagto.NONE;
}


export class LVPedEndereco extends BaseData {
  readonly jclass: string = "com.macle.site.vo.LVPedEndereco";
  endereco: string = "";
  cidade: string = "";
  CEP: number = 0;
  bairro: string = "";
  numero: string = "";
  infReferencia: string = "";
  retirarLoja: boolean = false;
  descricaoEndereco: string = "";
  estado: string = "";
}


export class LVDataTransacaoRedecardResult extends BaseData {
  readonly jclass: string = "com.macle.site.vo.LVDataTransacaoRedecardResult";
  data: string = "";
  descricao: string = "";
  codRetorno: number = 0;
  nroAutorizacao: number = 0;
  nroSeqUnico: string = "";
  nsuAutorizacao: string = "";
  codPaisEmissor: string = "";
  nroAutenticacao: string = "";
  descricaoRetorno: string = "";
  codConfirmacaoAutomatica: number = 0;
  pedido: LVPKPedido = new LVPKPedido();
}


export class BaseTransp extends BaseData {
  readonly jclass: string = "com.macle.site.vo.BaseTransp";
  codLOG: number = 0;

  constructor()
  constructor(codLOG: number)
  constructor(codLOG?: number) {
    super();
    this.codLOG = codLOG || 0;
  }

  public getPK(): BaseTransp {
    return new BaseTransp(this.codLOG);
  }

  public equals(arg: BaseTransp): boolean {
    return arg 
        && (arg.codLOG === this.codLOG)
    ;
  }
}


export class LVPKItem extends BaseTransp {
  readonly jclass: string = "com.macle.site.vo.LVPKItem";
  codItem: number = 0;
  codEmpresa: number = 0;

  constructor()
  constructor(codLOG: number, codEmpresa: number, codItem: number)
  constructor(codLOG?: number, codEmpresa?: number, codItem?: number) {
    super();
    this.codLOG = codLOG || 0;
    this.codEmpresa = codEmpresa || 0;
    this.codItem = codItem || 0;
  }

  public getPK(): LVPKItem {
    return new LVPKItem(this.codLOG, this.codEmpresa, this.codItem);
  }

  public equals(arg: LVPKItem): boolean {
    return arg && super.equals(arg)
        && (arg.codItem === this.codItem)
        && (arg.codEmpresa === this.codEmpresa)
    ;
  }
}


export class LVCorItem extends BaseData {
  readonly jclass: string = "com.macle.site.vo.LVCorItem";
  codItem: LVPKItem = new LVPKItem();
  codCor: number = 0;
  descCor: string = "";
}


export class LVDataTamanho extends BaseData {
  readonly jclass: string = "com.macle.site.vo.LVDataTamanho";
  codTamanho: number = 0;
  qtdEstoque: number = 0;
  descTamanho: string = "";
  EAN: string = "";
  ordem: number = 0;
}


export class LVPedItem extends LVPKPedido {
  readonly jclass: string = "com.macle.site.vo.LVPedItem";
  qtd: number = 0;
  descricao: string = "";
  codItem: LVPKItem = new LVPKItem();
  cor: LVCorItem = new LVCorItem();
  tamanho: LVDataTamanho = new LVDataTamanho();
  embalar: boolean = false;
  precoUnit: number = 0;
}


export class LVPKClienteSite extends BaseData {
  readonly jclass: string = "com.macle.site.vo.LVPKClienteSite";
  codDependente: number = 0;
  codCliente: number = 0;
  codEmpCli: number = 0;
  codSite: number = 0;

  constructor()
  constructor(codSite: number, codEmpCli: number, codCliente: number, codDependente: number)
  constructor(codSite?: number, codEmpCli?: number, codCliente?: number, codDependente?: number) {
    super();
    this.codSite = codSite || 0;
    this.codEmpCli = codEmpCli || 0;
    this.codCliente = codCliente || 0;
    this.codDependente = codDependente || 0;
  }

  public getPK(): LVPKClienteSite {
    return new LVPKClienteSite(this.codSite, this.codEmpCli, this.codCliente, this.codDependente);
  }

  public equals(arg: LVPKClienteSite): boolean {
    return arg 
        && (arg.codDependente === this.codDependente)
        && (arg.codCliente === this.codCliente)
        && (arg.codEmpCli === this.codEmpCli)
        && (arg.codSite === this.codSite)
    ;
  }
}


export class LVDataVendedor extends LVPKVendedor {
  readonly jclass: string = "com.macle.site.vo.LVDataVendedor";
  nome: string = "";
  nickName: string = "";
  listPed: ArrayList<LVPKPedido> = new ArrayList<LVPKPedido>(LVPKPedido);
}


export class LVPedCliente extends LVPKClienteSite {
  readonly jclass: string = "com.macle.site.vo.LVPedCliente";
  dataNascimento: string = "";
  email: string = "";
  sexo: ESexo = ESexo.NONE;
  vendedor: LVDataVendedor = new LVDataVendedor();
  enderecoEntrega: LVPedEndereco = new LVPedEndereco();
  telCelular: string = "";
  telResidencial: string = "";
  enderecoCobranca: LVPedEndereco = new LVPedEndereco();
  CPF: string = "";
  senha: string = "";
  nomeCli: string = "";
}


export class LVPedStatsSO extends BaseData {
  readonly jclass: string = "com.macle.site.vo.LVPedStatsSO";
  SO: string = "";
}


export class LVPedStats extends BaseData {
  readonly jclass: string = "com.macle.site.vo.LVPedStats";
  SO: LVPedStatsSO = new LVPedStatsSO();
  browser: LVPedStatsBrowser = new LVPedStatsBrowser();
  ipCliente: string = "";
}


export class LVPedFrete extends BaseData {
  readonly jclass: string = "com.macle.site.vo.LVPedFrete";
  CEP: number = 0;
  prazoEntrega: string = "";
  tipoFrete: ETipoFrete = ETipoFrete.NONE;
  valorFrete: number = 0;
  nroObjetoPac: string = "";
}


export class LVPedFormaPagto extends BaseData {
  readonly jclass: string = "com.macle.site.vo.LVPedFormaPagto";
  nome: string = "";
  formaPagamento: EFormaPagto = EFormaPagto.NONE;
  nroParcelas: number = 0;
  codSeguranca: string = "";
  numCartao: string = "";
  valAno: string = "";
  valMes: string = "";
}


export class LVPedido extends LVPKPedido {
  readonly jclass: string = "com.macle.site.vo.LVPedido";
  data: string = "";
  hora: string = "";
  enviadoSistema: boolean = false;
  status: EStatusPedido = EStatusPedido.NONE;
  vendedor: LVPKVendedor = new LVPKVendedor();
  tipoPagto: ETipoPagto = ETipoPagto.NONE;
  pedTransacaoCielo: LVDataTransacaoCieloResult = new LVDataTransacaoCieloResult();
  pedEnderecoEntrega: LVPedEndereco = new LVPedEndereco();
  pedTransacaoRedecard: LVDataTransacaoRedecardResult = new LVDataTransacaoRedecardResult();
  pedEnderecoComprador: LVPedEndereco = new LVPedEndereco();
  requestPedido: number = 0;
  listPedItem: ArrayList<LVPedItem> = new ArrayList<LVPedItem>(LVPedItem);
  pedCliente: LVPedCliente = new LVPedCliente();
  pedStats: LVPedStats = new LVPedStats();
  pedidoFinalizado: boolean = false;
  pedFrete: LVPedFrete = new LVPedFrete();
  pedFormaPagto: LVPedFormaPagto = new LVPedFormaPagto();
}


export class PKPedidoVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.PKPedidoVit";
  codPedido: number = 0;

  constructor()
  constructor(codPedido: number)
  constructor(codPedido?: number) {
    super();
    this.codPedido = codPedido || 0;
  }

  public getPK(): PKPedidoVit {
    return new PKPedidoVit(this.codPedido);
  }

  public equals(arg: PKPedidoVit): boolean {
    return arg 
        && (arg.codPedido === this.codPedido)
    ;
  }
}


export class PKClienteMacleVitPub extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.PKClienteMacleVitPub";
  codClienteMacle: number = 0;
}


export class PKPedidoVitPub extends PKPedidoVit {
  readonly jclass: string = "com.macle.vitrine.vo.PKPedidoVitPub";
  clienteMacle: PKClienteMacleVitPub = new PKClienteMacleVitPub();

  constructor()
  constructor(codPedido: number, clienteMacle: PKClienteMacleVitPub)
  constructor(codPedido?: number, clienteMacle?: PKClienteMacleVitPub) {
    super();
    this.codPedido = codPedido || 0;
    this.clienteMacle = clienteMacle ||  new PKClienteMacleVitPub();
  }

  public getPK(): PKPedidoVitPub {
    return new PKPedidoVitPub(this.codPedido, this.clienteMacle);
  }

  public equals(arg: PKPedidoVitPub): boolean {
    return arg && super.equals(arg)
        && (arg.clienteMacle === this.clienteMacle)
    ;
  }
}


export class DataEntregaDistanciaAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataEntregaDistanciaAPP";
  origem: string = "";
  destino: string = "";
  duracaoViagemSegundos: number = 0;
  distanciaKM: number = 0;
}


export class DataPedidoEntregaVitPub extends PKPedidoVitPub {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoEntregaVitPub";
  frete: DataFreteAPP = new DataFreteAPP();
  taxaEntrega: number = 0;
  retiradaLoja: boolean = false;
  distancia: DataEntregaDistanciaAPP = new DataEntregaDistanciaAPP();
  codEmpresaRetiradaLoja: number = 0;
}


export enum EOrdenacaoItem {
  NONE = 0,
  MAIS_RELEVANTE = 1,
  MENORES_PRECOS = 2,
  MAIORES_PRECOS = 3,
  MAIORES_DESCONTOS = 4,
}

export namespace EOrdenacaoItem {
  export function toDisplay(arg: EOrdenacaoItem): string {
    switch (arg) {
      case 0: return "";
      case 1: return "Mais relevantes";
      case 2: return "Menores precos";
      case 3: return "Maiores precos";
      case 4: return "Maiores descontos";
      default: return "";
    }
  }

  export function enums(): EOrdenacaoItem[] {
    return [EOrdenacaoItem.NONE,EOrdenacaoItem.MAIS_RELEVANTE,EOrdenacaoItem.MENORES_PRECOS,EOrdenacaoItem.MAIORES_PRECOS,EOrdenacaoItem.MAIORES_DESCONTOS];
  }
}


export class PKItemVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.PKItemVit";
  codItemVit: number = 0;

  constructor()
  constructor(codItemVit: number)
  constructor(codItemVit?: number) {
    super();
    this.codItemVit = codItemVit || 0;
  }

  public getPK(): PKItemVit {
    return new PKItemVit(this.codItemVit);
  }

  public equals(arg: PKItemVit): boolean {
    return arg 
        && (arg.codItemVit === this.codItemVit)
    ;
  }
}


export class PKItemLojaVitPub extends PKItemVit {
  readonly jclass: string = "com.macle.vitrine.vo.PKItemLojaVitPub";
  clienteMacle: PKClienteMacleVitPub = new PKClienteMacleVitPub();

  constructor()
  constructor(codItemVit: number, clienteMacle: PKClienteMacleVitPub)
  constructor(codItemVit?: number, clienteMacle?: PKClienteMacleVitPub) {
    super();
    this.codItemVit = codItemVit || 0;
    this.clienteMacle = clienteMacle ||  new PKClienteMacleVitPub();
  }

  public getPK(): PKItemLojaVitPub {
    return new PKItemLojaVitPub(this.codItemVit, this.clienteMacle);
  }

  public equals(arg: PKItemLojaVitPub): boolean {
    return arg && super.equals(arg)
        && (arg.clienteMacle === this.clienteMacle)
    ;
  }
}


export class PKVendaVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.PKVendaVit";
  codVenda: number = 0;

  constructor()
  constructor(codVenda: number)
  constructor(codVenda?: number) {
    super();
    this.codVenda = codVenda || 0;
  }

  public getPK(): PKVendaVit {
    return new PKVendaVit(this.codVenda);
  }

  public equals(arg: PKVendaVit): boolean {
    return arg 
        && (arg.codVenda === this.codVenda)
    ;
  }
}


export class PKVendedorAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.PKVendedorAPP";
  codVendedor: number = 0;
  codEmpVendedor: number = 0;

  constructor()
  constructor(codEmpVendedor: number, codVendedor: number)
  constructor(codEmpVendedor?: number, codVendedor?: number) {
    super();
    this.codEmpVendedor = codEmpVendedor || 0;
    this.codVendedor = codVendedor || 0;
  }

  public getPK(): PKVendedorAPP {
    return new PKVendedorAPP(this.codEmpVendedor, this.codVendedor);
  }

  public equals(arg: PKVendedorAPP): boolean {
    return arg 
        && (arg.codVendedor === this.codVendedor)
        && (arg.codEmpVendedor === this.codEmpVendedor)
    ;
  }
}


export class PKTamanhoItemVit extends PKItemVit {
  readonly jclass: string = "com.macle.vitrine.vo.PKTamanhoItemVit";
  codTamanho: number = 0;

  constructor()
  constructor(codItemVit: number, codTamanho: number)
  constructor(codItemVit?: number, codTamanho?: number) {
    super();
    this.codItemVit = codItemVit || 0;
    this.codTamanho = codTamanho || 0;
  }

  public getPK(): PKTamanhoItemVit {
    return new PKTamanhoItemVit(this.codItemVit, this.codTamanho);
  }

  public equals(arg: PKTamanhoItemVit): boolean {
    return arg && super.equals(arg)
        && (arg.codTamanho === this.codTamanho)
    ;
  }
}


export class PKItemControleVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.PKItemControleVit";
  codItemControle: number = 0;
  codEmpresaControle: number = 0;

  constructor()
  constructor(codEmpresaControle: number, codItemControle: number)
  constructor(codEmpresaControle?: number, codItemControle?: number) {
    super();
    this.codEmpresaControle = codEmpresaControle || 0;
    this.codItemControle = codItemControle || 0;
  }

  public getPK(): PKItemControleVit {
    return new PKItemControleVit(this.codEmpresaControle, this.codItemControle);
  }

  public equals(arg: PKItemControleVit): boolean {
    return arg 
        && (arg.codItemControle === this.codItemControle)
        && (arg.codEmpresaControle === this.codEmpresaControle)
    ;
  }
}


export class DataVendaItemVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataVendaItemVit";
  item: PKTamanhoItemVit = new PKTamanhoItemVit();
  qtd: number = 0;
  descricao: string = "";
  descricaoTamanho: string = "";
  desconto: number = 0;
  precoUnitario: number = 0;
  precoCongelado: boolean = false;
  gtin: string = "";
  imgItemURL: string = "";
  descricaoMarca: string = "";
  itemControle: PKItemControleVit = new PKItemControleVit();
  descricaoCor: string = "";
  imgPequenoURL: string = "";
  googleCategory: string = "";
  codCupomDesconto: number = 0;

  constructor()
  constructor(item: PKTamanhoItemVit, gtin: string, descricaoTamanho: string, itemControle: PKItemControleVit, descricao: string, googleCategory: string, descricaoCor: string, descricaoMarca: string, imgItemURL: string, qtd: number, precoUnitario: number, desconto: number, precoCongelado: boolean)
  constructor(item?: PKTamanhoItemVit, gtin?: string, descricaoTamanho?: string, itemControle?: PKItemControleVit, descricao?: string, googleCategory?: string, descricaoCor?: string, descricaoMarca?: string, imgItemURL?: string, qtd?: number, precoUnitario?: number, desconto?: number, precoCongelado?: boolean) {
    super();
    this.item = item ||  new PKTamanhoItemVit();
    this.gtin = gtin || "";
    this.descricaoTamanho = descricaoTamanho || "";
    this.itemControle = itemControle ||  new PKItemControleVit();
    this.descricao = descricao || "";
    this.googleCategory = googleCategory || "";
    this.descricaoCor = descricaoCor || "";
    this.descricaoMarca = descricaoMarca || "";
    this.imgItemURL = imgItemURL || "";
    this.qtd = qtd || 0;
    this.precoUnitario = precoUnitario || 0;
    this.desconto = desconto || 0;
    this.precoCongelado = precoCongelado || false;
  }

  public getPK(): DataVendaItemVit {
    return new DataVendaItemVit(this.item, this.gtin, this.descricaoTamanho, this.itemControle, this.descricao, this.googleCategory, this.descricaoCor, this.descricaoMarca, this.imgItemURL, this.qtd, this.precoUnitario, this.desconto, this.precoCongelado);
  }

  public equals(arg: DataVendaItemVit): boolean {
    return arg 
        && (arg.item === this.item)
        && (arg.qtd === this.qtd)
        && (arg.descricao === this.descricao)
        && (arg.descricaoTamanho === this.descricaoTamanho)
        && (arg.desconto === this.desconto)
        && (arg.precoUnitario === this.precoUnitario)
        && (arg.precoCongelado === this.precoCongelado)
        && (arg.gtin === this.gtin)
        && (arg.imgItemURL === this.imgItemURL)
        && (arg.descricaoMarca === this.descricaoMarca)
        && (arg.itemControle === this.itemControle)
        && (arg.descricaoCor === this.descricaoCor)
        && (arg.imgPequenoURL === this.imgPequenoURL)
        && (arg.googleCategory === this.googleCategory)
        && (arg.codCupomDesconto === this.codCupomDesconto)
    ;
  }
}


export class PKPedidoCupomDesconto extends PKPedidoVit {
  readonly jclass: string = "com.macle.vitrine.vo.PKPedidoCupomDesconto";
  codCupomDesconto: number = 0;

  constructor()
  constructor(codPedido: number, codCupomDesconto: number)
  constructor(codPedido?: number, codCupomDesconto?: number) {
    super();
    this.codPedido = codPedido || 0;
    this.codCupomDesconto = codCupomDesconto || 0;
  }

  public getPK(): PKPedidoCupomDesconto {
    return new PKPedidoCupomDesconto(this.codPedido, this.codCupomDesconto);
  }

  public equals(arg: PKPedidoCupomDesconto): boolean {
    return arg && super.equals(arg)
        && (arg.codCupomDesconto === this.codCupomDesconto)
    ;
  }
}


export enum EModoCreditoClienteVit {
  NONE = 0,
  VALOR = 1,
  PERCENT_ITEM = 2,
  PERCENT_VENDA = 3,
}

export namespace EModoCreditoClienteVit {
  export function toDisplay(arg: EModoCreditoClienteVit): string {
    switch (arg) {
      case 0: return "";
      case 1: return "Valor";
      case 2: return "Percentual item";
      case 3: return "Percentual venda";
      default: return "";
    }
  }

  export function enums(): EModoCreditoClienteVit[] {
    return [EModoCreditoClienteVit.NONE,EModoCreditoClienteVit.VALOR,EModoCreditoClienteVit.PERCENT_ITEM,EModoCreditoClienteVit.PERCENT_VENDA];
  }
}


export class DataPedidoCupomDesconto extends PKPedidoCupomDesconto {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoCupomDesconto";
  ID: string = "";
  item: PKTamanhoItemVit = new PKTamanhoItemVit();
  data: string = "";
  modo: EModoCreditoClienteVit = EModoCreditoClienteVit.NONE;
  creditoCliente: boolean = false;
  valorCupom: number = 0;
  valorPedido: number = 0;
}


export class DataVendaVit extends PKVendaVit {
  readonly jclass: string = "com.macle.vitrine.vo.DataVendaVit";
  data: string = "";
  hora: string = "";
  valor: number = 0;
  desconto: number = 0;
  codEmpresaVenda: number = 0;
  vendedor: PKVendedorAPP = new PKVendedorAPP();
  codVitrineVenda: number = 0;
  listItem: ArrayList<DataVendaItemVit> = new ArrayList<DataVendaItemVit>(DataVendaItemVit);
  precoTotalVenda: number = 0;
  qtdItensVenda: number = 0;
  listCupomDesconto: ArrayList<DataPedidoCupomDesconto> = new ArrayList<DataPedidoCupomDesconto>(DataPedidoCupomDesconto);
}


export enum EClasseItemSite {
  NONE = "''",
  NORMAL = "'N'",
  PROMOCAO = "'P'",
  LANCAMENTO = "'L'",
  DESTAQUE = "'D'",
  TODOS_SITE = "'TODOS_SITE'",
  FORA_SITE = "'FORA_SITE'",
}

export namespace EClasseItemSite {
  export function toDisplay(arg: EClasseItemSite): string {
    switch (arg) {
      case "''": return "";
      case "'N'": return "Normal";
      case "'P'": return "Promo&ccedil;&atilde;o";
      case "'L'": return "Lan&ccedil;amento";
      case "'D'": return "Destaque";
      case "'TODOS_SITE'": return "Todos do site";
      case "'FORA_SITE'": return "Fora do site";
      default: return "";
    }
  }

  export function enums(): EClasseItemSite[] {
    return [EClasseItemSite.NONE,EClasseItemSite.NORMAL,EClasseItemSite.PROMOCAO,EClasseItemSite.LANCAMENTO,EClasseItemSite.DESTAQUE,EClasseItemSite.TODOS_SITE,EClasseItemSite.FORA_SITE];
  }
}


export class FilterItemVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.FilterItemVit";
  descricao: string = "";
  codTamanho: number = 0;
  ativo: EFilterBool = EFilterBool.NONE;
  ordenacao: EOrdenacaoItem = EOrdenacaoItem.NONE;
  gtin: number = 0;
  genero: EGenero = EGenero.NONE;
  ltipos: number[] = [];
  lmarcas: number[] = [];
  precoMax: number = 0;
  precoMin: number = 0;
  classeSite: EClasseItemSite = EClasseItemSite.NONE;
  itemControle: PKItemControleVit = new PKItemControleVit();
  faixaEtaria: EFaixaEtaria = EFaixaEtaria.NONE;
  hashtags: number[] = [];
}


export class FiltroNodeItemAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.FiltroNodeItemAPP";
  descricao: string = "";
  quantidade: number = 0;
  codigo: number = 0;
}


export class FiltroNodeAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.FiltroNodeAPP";
  value: number = 0;
  nome: string = "";
  lista: ArrayList<FiltroNodeItemAPP> = new ArrayList<FiltroNodeItemAPP>(FiltroNodeItemAPP);
  display: string = "";
  visivel: boolean = false;
}


export enum EVersaoIntegracaoPagarmeAPP {
  NONE = 0,
  V2 = 1,
  V5 = 2,
  V6 = 3,
}

export namespace EVersaoIntegracaoPagarmeAPP {
  export function toDisplay(arg: EVersaoIntegracaoPagarmeAPP): string {
    switch (arg) {
      case 0: return "";
      case 1: return "Pagar.me V2";
      case 2: return "Pagar.me V5";
      case 3: return "Zoop";
      default: return "";
    }
  }

  export function enums(): EVersaoIntegracaoPagarmeAPP[] {
    return [EVersaoIntegracaoPagarmeAPP.NONE,EVersaoIntegracaoPagarmeAPP.V2,EVersaoIntegracaoPagarmeAPP.V5,EVersaoIntegracaoPagarmeAPP.V6];
  }
}


export class PKParcelaAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.PKParcelaAPP";
  codParcela: number = 0;
  codEmpresaParcela: number = 0;

  constructor()
  constructor(codEmpresaParcela: number, codParcela: number)
  constructor(codEmpresaParcela?: number, codParcela?: number) {
    super();
    this.codEmpresaParcela = codEmpresaParcela || 0;
    this.codParcela = codParcela || 0;
  }

  public getPK(): PKParcelaAPP {
    return new PKParcelaAPP(this.codEmpresaParcela, this.codParcela);
  }

  public equals(arg: PKParcelaAPP): boolean {
    return arg 
        && (arg.codParcela === this.codParcela)
        && (arg.codEmpresaParcela === this.codEmpresaParcela)
    ;
  }
}


export class DataSendDadosEmissaoBoletoAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataSendDadosEmissaoBoletoAPP";
  versaoEmissaoAPP: EVersaoIntegracaoPagarmeAPP = EVersaoIntegracaoPagarmeAPP.NONE;
  listPkParc: ArrayList<PKParcelaAPP> = new ArrayList<PKParcelaAPP>(PKParcelaAPP);
  dadosEmissaoAPP: string = "";
}


export class PKItemAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.PKItemAPP";
  codItem: number = 0;
  codEmpItem: number = 0;

  constructor()
  constructor(codEmpItem: number, codItem: number)
  constructor(codEmpItem?: number, codItem?: number) {
    super();
    this.codEmpItem = codEmpItem || 0;
    this.codItem = codItem || 0;
  }

  public getPK(): PKItemAPP {
    return new PKItemAPP(this.codEmpItem, this.codItem);
  }

  public equals(arg: PKItemAPP): boolean {
    return arg 
        && (arg.codItem === this.codItem)
        && (arg.codEmpItem === this.codEmpItem)
    ;
  }
}


export class PKTamanhoItemAPP extends PKItemAPP {
  readonly jclass: string = "com.macle.app.vo.PKTamanhoItemAPP";
  codTamanho: number = 0;

  constructor()
  constructor(codEmpItem: number, codItem: number, codTamanho: number)
  constructor(codEmpItem?: number, codItem?: number, codTamanho?: number) {
    super();
    this.codEmpItem = codEmpItem || 0;
    this.codItem = codItem || 0;
    this.codTamanho = codTamanho || 0;
  }

  public getPK(): PKTamanhoItemAPP {
    return new PKTamanhoItemAPP(this.codEmpItem, this.codItem, this.codTamanho);
  }

  public equals(arg: PKTamanhoItemAPP): boolean {
    return arg && super.equals(arg)
        && (arg.codTamanho === this.codTamanho)
    ;
  }
}


export class DataPedidoItemVit extends PKPedidoVit {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoItemVit";
  item: PKTamanhoItemAPP = new PKTamanhoItemAPP();
  qtd: number = 0;
  descricao: string = "";
  itemVit: PKTamanhoItemVit = new PKTamanhoItemVit();
  desconto: number = 0;
  precoUnitario: number = 0;
  codCupomDesconto: number = 0;
}


export class PKPagarMeTransacaoAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.PKPagarMeTransacaoAPP";
  codPagarMeTransacao: number = 0;

  constructor()
  constructor(codPagarMeTransacao: number)
  constructor(codPagarMeTransacao?: number) {
    super();
    this.codPagarMeTransacao = codPagarMeTransacao || 0;
  }

  public getPK(): PKPagarMeTransacaoAPP {
    return new PKPagarMeTransacaoAPP(this.codPagarMeTransacao);
  }

  public equals(arg: PKPagarMeTransacaoAPP): boolean {
    return arg 
        && (arg.codPagarMeTransacao === this.codPagarMeTransacao)
    ;
  }
}


export class DataFrenetCotacaoServicoVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetCotacaoServicoVit";
  ownHand: boolean = false;
  declaredValue: boolean = false;
  receiptNotification: boolean = false;
}


export class PKLiquidacaoParcelaAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.PKLiquidacaoParcelaAPP";
  codLiquidacaoParcela: number = 0;

  constructor()
  constructor(codLiquidacaoParcela: number)
  constructor(codLiquidacaoParcela?: number) {
    super();
    this.codLiquidacaoParcela = codLiquidacaoParcela || 0;
  }

  public getPK(): PKLiquidacaoParcelaAPP {
    return new PKLiquidacaoParcelaAPP(this.codLiquidacaoParcela);
  }

  public equals(arg: PKLiquidacaoParcelaAPP): boolean {
    return arg 
        && (arg.codLiquidacaoParcela === this.codLiquidacaoParcela)
    ;
  }
}


export class PKClienteAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.PKClienteAPP";
  codCliente: number = 0;
  codEmpresaCliente: number = 0;

  constructor()
  constructor(codEmpresaCliente: number, codCliente: number)
  constructor(codEmpresaCliente?: number, codCliente?: number) {
    super();
    this.codEmpresaCliente = codEmpresaCliente || 0;
    this.codCliente = codCliente || 0;
  }

  public getPK(): PKClienteAPP {
    return new PKClienteAPP(this.codEmpresaCliente, this.codCliente);
  }

  public equals(arg: PKClienteAPP): boolean {
    return arg 
        && (arg.codCliente === this.codCliente)
        && (arg.codEmpresaCliente === this.codEmpresaCliente)
    ;
  }
}


export class PKDependenteAPP extends PKClienteAPP {
  readonly jclass: string = "com.macle.app.vo.PKDependenteAPP";
  codDependente: number = 0;

  constructor()
  constructor(codEmpresaCliente: number, codCliente: number, codDependente: number)
  constructor(codEmpresaCliente?: number, codCliente?: number, codDependente?: number) {
    super();
    this.codEmpresaCliente = codEmpresaCliente || 0;
    this.codCliente = codCliente || 0;
    this.codDependente = codDependente || 0;
  }

  public getPK(): PKDependenteAPP {
    return new PKDependenteAPP(this.codEmpresaCliente, this.codCliente, this.codDependente);
  }

  public equals(arg: PKDependenteAPP): boolean {
    return arg && super.equals(arg)
        && (arg.codDependente === this.codDependente)
    ;
  }
}


export enum EStatusLiquidacaoAPP {
  NONE = 0,
  PENDENTE = 1,
  LIQUIDADO = 2,
  EXPIRADA = 3,
}

export namespace EStatusLiquidacaoAPP {
  export function toDisplay(arg: EStatusLiquidacaoAPP): string {
    switch (arg) {
      case 0: return "";
      case 1: return "Pendente";
      case 2: return "Liquidado";
      case 3: return "Expirada";
      default: return "";
    }
  }

  export function enums(): EStatusLiquidacaoAPP[] {
    return [EStatusLiquidacaoAPP.NONE,EStatusLiquidacaoAPP.PENDENTE,EStatusLiquidacaoAPP.LIQUIDADO,EStatusLiquidacaoAPP.EXPIRADA];
  }
}


export class DataLiquidacaoParcelaAPP extends PKLiquidacaoParcelaAPP {
  readonly jclass: string = "com.macle.app.vo.DataLiquidacaoParcelaAPP";
  data: string = "";
  hora: string = "";
  ativo: boolean = false;
  valor: number = 0;
  versaointegracao: EVersaoIntegracaoPagarmeAPP = EVersaoIntegracaoPagarmeAPP.NONE;
  dataHoraValidadePIX: string = "";
  cliente: PKDependenteAPP = new PKDependenteAPP();
  transactionId: string = "";
  listParcela: ArrayList<PKParcelaAPP> = new ArrayList<PKParcelaAPP>(PKParcelaAPP);
  formaPagamento: EFormaPagamentoAPP = EFormaPagamentoAPP.NONE;
  lineBoleto: string = "";
  enviadoSistema: boolean = false;
  vencimento: string = "";
  qrCodePIX: string = "";
  idPedido: string = "";
  qrCodePIXBase64: string = "";
  codEmpresa: number = 0;
  urlBoleto: string = "";
  barcodeBoleto: string = "";
  status: EStatusLiquidacaoAPP = EStatusLiquidacaoAPP.NONE;
  conta: PKContaAPP = new PKContaAPP();
}


export class DataNovoClienteAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataNovoClienteAPP";
  endereco: string = "";
  telefone: string = "";
  email: string = "";
  nome: string = "";
  cidade: string = "";
  bairro: string = "";
  numero: string = "";
  nascimento: string = "";
  complemento: string = "";
  cep: string = "";
  cpf: string = "";
  uf: string = "";
}


export class FilterNCE extends BaseData {
  readonly jclass: string = "com.macle.app.vo.FilterNCE";
  descricao: string = "";
  refFornecedor: string = "";
  codTamanho: number = 0;
  nivel6: number = 0;
  nivel1: number = 0;
  nivel2: number = 0;
  nivel7: number = 0;
  nivel4: number = 0;
  nivel5: number = 0;
  nivel8: number = 0;
  nivel3: number = 0;
  promo: boolean = false;
  nivel9: number = 0;
  exibeItemZerado: boolean = false;
  minFaixaPreco: number = 0;
  maxFaixaPreco: number = 0;
  codEmpresaLogin: number = 0;
  codMarca: number = 0;
  exibeEstoqueApenasLoja: boolean = false;
  public equals(arg: FilterNCE): boolean {
    return arg 
        && (arg.descricao === this.descricao)
        && (arg.refFornecedor === this.refFornecedor)
        && (arg.codTamanho === this.codTamanho)
        && (arg.nivel6 === this.nivel6)
        && (arg.nivel1 === this.nivel1)
        && (arg.nivel2 === this.nivel2)
        && (arg.nivel7 === this.nivel7)
        && (arg.nivel4 === this.nivel4)
        && (arg.nivel5 === this.nivel5)
        && (arg.nivel8 === this.nivel8)
        && (arg.nivel3 === this.nivel3)
        && (arg.promo === this.promo)
        && (arg.nivel9 === this.nivel9)
        && (arg.exibeItemZerado === this.exibeItemZerado)
        && (arg.minFaixaPreco === this.minFaixaPreco)
        && (arg.maxFaixaPreco === this.maxFaixaPreco)
        && (arg.codEmpresaLogin === this.codEmpresaLogin)
        && (arg.codMarca === this.codMarca)
        && (arg.exibeEstoqueApenasLoja === this.exibeEstoqueApenasLoja)
    ;
  }
}


export class DataMarcaItemVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataMarcaItemVit";
  descricaoMarca: string = "";
  codigoMarca: number = 0;
}


export class DataFrenetShippingServiceResponseVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetShippingServiceResponseVit";
  error: boolean = false;
  shippingPrice: number = 0;
  msg: string = "";
  carrier: string = "";
  carrierCode: string = "";
  serviceCode: string = "";
  deliveryTime: number = 0;
  originalDeliveryTime: number = 0;
  originalShippingPrice: number = 0;
  serviceDescription: string = "";
}


export class DataShareItemAPP extends PKItemAPP {
  readonly jclass: string = "com.macle.app.vo.DataShareItemAPP";
  imgNome: string = "";
  descItem: string = "";
  imgBase64: string = "";
}


export class DataPedidoClienteVit extends PKPedidoVit {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoClienteVit";
  telefone: string = "";
  dataNascimento: string = "";
  email: string = "";
  sexo: ESexo = ESexo.NONE;
  nome: string = "";
  cnpj: string = "";
  cliente: PKDependenteAPP = new PKDependenteAPP();
  inscEstadual: string = "";
  senha: string = "";
  codClienteVit: number = 0;
}


export class DataPackIdOrdersResultML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPackIdOrdersResultML";
  id: number = 0;
  static_tags: string[] = [];
}


export class DataPackIdResultML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPackIdResultML";
  id: number = 0;
  status: string = "";
  orders: ArrayList<DataPackIdOrdersResultML> = new ArrayList<DataPackIdOrdersResultML>(DataPackIdOrdersResultML);
  buyer: DataPedidoCompradorML = new DataPedidoCompradorML();
  date_created: string = "";
  family_pack_id: number = 0;
  trash_pack_id: number = 0;
  status_detail: string = "";
  last_updated: string = "";
  shipment: DataPedidoShippingML = new DataPedidoShippingML();
}


export class ConsumidorSiteResponseGetConsumidorV0APP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.ConsumidorSiteResponseGetConsumidorV0APP";
  chaveConfirmacao: number = 0;
  clienteLocalizado: boolean = false;
  urlConsultaVendedor: string = "";
  envioConfirmacao: string = "";
  vendedor: boolean = false;
  token: string = "";
  tipoConfirmacao: ETipoConfirmacaoConsumidorSiteAPP = ETipoConfirmacaoConsumidorSiteAPP.NONE;
  pkCliente: PKDependenteAPP = new PKDependenteAPP();
  confirmado: boolean = false;
}


export class ConsVendedorAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.ConsVendedorAPP";
  nome: string = "";
  listEmpresa: number[] = [];
  codVendedor: number = 0;
  fotoBase64: string = "";
  whatsApp: number = 0;
  codEmpVendedor: number = 0;
}


export class PKVendaAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.PKVendaAPP";
  codVenda: number = 0;

  constructor()
  constructor(codVenda: number)
  constructor(codVenda?: number) {
    super();
    this.codVenda = codVenda || 0;
  }

  public getPK(): PKVendaAPP {
    return new PKVendaAPP(this.codVenda);
  }

  public equals(arg: PKVendaAPP): boolean {
    return arg 
        && (arg.codVenda === this.codVenda)
    ;
  }
}


export class DataVendaVitrinePublicaAPP extends PKVendaAPP {
  readonly jclass: string = "com.macle.app.vo.DataVendaVitrinePublicaAPP";
  clienteMacle: ArrayList<PKClienteMacleVitPub> = new ArrayList<PKClienteMacleVitPub>(PKClienteMacleVitPub);
}


export class DataFrenetEnderecoVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetEnderecoVit";
  country: string = "";
  city: string = "";
  zipCode: string = "";
  street: string = "";
  postalBoxCode: string = "";
  addressQuarter: string = "";
  enderecoCompleto: boolean = false;
  addressNumber: string = "";
  addressState: string = "";
  addressComplement: string = "";
}


export class DataFrenetPedidoEtiquetaClienteVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetPedidoEtiquetaClienteVit";
  name: string = "";
  address: DataFrenetEnderecoVit = new DataFrenetEnderecoVit();
  email: string = "";
  phone: string = "";
  IE: string = "";
  document: string = "";
  cellphone: string = "";
}


export class DataResultEmitePixPedido extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataResultEmitePixPedido";
  valor: number = 0;
  dataHoraValidade: string = "";
  codMaclePagto: number = 0;
  pixCode: string = "";
  qrCodePix: string = "";
}


export class DataResultEmiteCartaoPedido extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataResultEmiteCartaoPedido";
  numeroCartao: string = "";
  nomeCartao: string = "";
  codMaclePagto: number = 0;
  codSeguranca: string = "";
  anoValidade: number = 0;
  qtdParcelas: number = 0;
  bandeira: string = "";
  mesValidade: number = 0;
  cnpjTitularCartao: string = "";
}


export class PKCondVendaAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.PKCondVendaAPP";
  codEmpresaCondVenda: number = 0;
  codCondVenda: number = 0;

  constructor()
  constructor(codEmpresaCondVenda: number, codCondVenda: number)
  constructor(codEmpresaCondVenda?: number, codCondVenda?: number) {
    super();
    this.codEmpresaCondVenda = codEmpresaCondVenda || 0;
    this.codCondVenda = codCondVenda || 0;
  }

  public getPK(): PKCondVendaAPP {
    return new PKCondVendaAPP(this.codEmpresaCondVenda, this.codCondVenda);
  }

  public equals(arg: PKCondVendaAPP): boolean {
    return arg 
        && (arg.codEmpresaCondVenda === this.codEmpresaCondVenda)
        && (arg.codCondVenda === this.codCondVenda)
    ;
  }
}


export class DataPedidoFormaPagamentoVit extends PKPedidoVit {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoFormaPagamentoVit";
  formaPagamento: EFormaPagamentoAPP = EFormaPagamentoAPP.NONE;
  cartao: DataResultEmiteCartaoPedido = new DataResultEmiteCartaoPedido();
  pix: DataResultEmitePixPedido = new DataResultEmitePixPedido();
  codMaclePagto: number = 0;
  condVenda: PKCondVendaAPP = new PKCondVendaAPP();
}


export enum EStatusPedidoPagamentoML {
  none = 0,
  rejected = 1,
  approved = 2,
  cancelled = 3,
  refunded = 4,
  in_mediation = 5,
  charged_back = 6,
}

export namespace EStatusPedidoPagamentoML {
  export function toDisplay(arg: EStatusPedidoPagamentoML): string {
    switch (arg) {
      case 0: return "";
      case 1: return "Pagamento rejeitado";
      case 2: return "Pagamento aprovado";
      case 3: return "Pagamento cancelado";
      case 4: return "Pagamento devolvido";
      case 5: return "Pagamento em media&ccedil;&atilde;o";
      case 6: return "Pagamento em chargeback";
      default: return "";
    }
  }

  export function enums(): EStatusPedidoPagamentoML[] {
    return [EStatusPedidoPagamentoML.none,EStatusPedidoPagamentoML.rejected,EStatusPedidoPagamentoML.approved,EStatusPedidoPagamentoML.cancelled,EStatusPedidoPagamentoML.refunded,EStatusPedidoPagamentoML.in_mediation,EStatusPedidoPagamentoML.charged_back];
  }
}


export class ConsImgItemAPP extends LVPKItem {
  readonly jclass: string = "com.macle.app.vo.ConsImgItemAPP";
  imagens: string[] = [];
}


export class DataVendaItemVitPub extends PKItemLojaVitPub {
  readonly jclass: string = "com.macle.vitrine.vo.DataVendaItemVitPub";
  qtd: number = 0;
  descricao: string = "";
  descricaoTamanho: string = "";
  codTamanho: number = 0;
  desconto: number = 0;
  precoUnitario: number = 0;
  precoCongelado: boolean = false;
  imgPequenoBase64: string = "";
  itemControle: PKItemControleVit = new PKItemControleVit();
}


export class DataVendaItemAPP extends PKVendaAPP {
  readonly jclass: string = "com.macle.app.vo.DataVendaItemAPP";
  item: PKTamanhoItemAPP = new PKTamanhoItemAPP();
  qtd: number = 0;
  descricao: string = "";
  itemVit: PKItemLojaVitPub = new PKItemLojaVitPub();
  desconto: number = 0;
  precoUnitario: number = 0;
  precoCongelado: boolean = false;
}


export class DataEmiteCartaoDeCreditoPagarMeAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataEmiteCartaoDeCreditoPagarMeAPP";
  valor: number = 0;
  dadosResumidos: boolean = false;
  endereco: string = "";
  telefone: string = "";
  email: string = "";
  nome: string = "";
  mesValidadeCartao: number = 0;
  codigoSegurancaCartao: string = "";
  enderecoComplemento: string = "";
  anoValidadeCartao: number = 0;
  cliente: PKDependenteAPP = new PKDependenteAPP();
  vendaVitrinePub: DataVendaVitrinePublicaAPP = new DataVendaVitrinePublicaAPP();
  numeroCartao: string = "";
  qtdParcela: number = 0;
  cardHash: string = "";
  nomeCartao: string = "";
  enderecoCidade: string = "";
  enderecoBairro: string = "";
  enderecoEstado: string = "";
  numeroDocumento: string = "";
  valorFrete: number = 0;
  enderecoNumero: string = "";
  listProduto: ArrayList<DataVendaItemAPP> = new ArrayList<DataVendaItemAPP>(DataVendaItemAPP);
  enderecoCEP: string = "";
  telefoneDDD: string = "";
}


export class DataVendaEnderecoAPP extends PKVendaAPP {
  readonly jclass: string = "com.macle.app.vo.DataVendaEnderecoAPP";
  endereco: DataEndereco = new DataEndereco();
}


export class DataParametrosAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataParametrosAPP";
  ativo: boolean = false;
  logoBase64: string = "";
  telefone: string = "";
  codContaBoletoLiquidacaoParcelaAplicativo: number = 0;
  pctDescontoBoletoAPP: number = 0;
  habilitaBoletoCompraAPP: boolean = false;
  habilitaCondicionalAPP: boolean = false;
  qtdMaxParcelaAPP: number = 0;
  taxaBoletoAbaixoDeAPP: number = 0;
  habilitaCartaoCompraAPP: boolean = false;
  cepOrigemSigepAPP: number = 0;
  servidorConsulta: string = "";
  valorMinParcelaAPP: number = 0;
  appVitrinePublica: boolean = false;
  habilitaBoletoParcelaAPP: boolean = false;
  habilitaPIXParcelaAPP: boolean = false;
  habilitaPIXCompraAPP: boolean = false;
  pctDescontoCompraPIXAPP: number = 0;
  habilitaComprasAPP: boolean = false;
  habilitaEntregaCompraAPP: boolean = false;
  chaveAPIPagarMe: string = "";
  idSellerZoop: string = "";
  dataReferencia: string = "";
  tokenFrenet: string = "";
  fantasia: string = "";
  whatsApp: number = 0;
  CNPJ: string = "";
  urlAPP: string = "";
  macleID: string = "";
  lconta: ArrayList<DataContaAPP> = new ArrayList<DataContaAPP>(DataContaAPP);
  valorTaxaEntregaCompraAbaixoDeAPP: number = 0;
  habilitaVisMensagemCompraWhatsAPP: boolean = false;
  distanciaMaximaEntregaCondicionalAPP: number = 0;
  habilitaSomenteConsultaParcelaAPP: boolean = false;
  taxaBoletoLiquidacaoParcelaAplicativo: number = 0;
  codEmpresaLiquidacaoParcelaAplicativo: number = 0;
  codEmpresaContaBoletoLiquidacaoParcelaAplicativo: number = 0;
  valorTaxaEntregaCompraAPP: number = 0;
  distanciaMaximaEntregaCompraAPP: number = 0;
  distanciaEntregaGratisCompraAPP: number = 0;
  habilitaLiquidacaoParcelaAPP: boolean = false;
  tipoFreteGratisCorreioAPP: ETipoFrete = ETipoFrete.NONE;
  pctDescontoCreditoCartaoAPP: number = 0;
  valorFreteGratisCorreioAPP: number = 0;
  qtdMaxParcelaCrediarioAPP: number = 0;
  chaveCriptografiaPagarMe: string = "";
  habilitaConsultaEstoqueVendedor: boolean = false;
  valorMinParcelaCrediarioAPP: number = 0;
  habilitaRetiradaLojaCompraAPP: boolean = false;
  empresaRetirataMercadoriaAPP: string = "";
  habilitaCrediarioCompraAPP: boolean = false;
  habilitaEntregaCorreiosAPP: boolean = false;
  valorTaxaEntregaCondicionalAPP: number = 0;
  diasValidadeLinkVendedorAPP: number = 0;
}


export class DataPedidoEntregaVit extends PKPedidoVit {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoEntregaVit";
  frete: DataFreteAPP = new DataFreteAPP();
  taxaEntrega: number = 0;
  retiradaLoja: boolean = false;
  distancia: DataEntregaDistanciaAPP = new DataEntregaDistanciaAPP();
  codEmpresaRetiradaLoja: number = 0;
}


export class PKDocVendaAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.PKDocVendaAPP";
  serie: number = 0;
  numero: number = 0;
  codEmpresa: number = 0;

  constructor()
  constructor(codEmpresa: number, serie: number, numero: number)
  constructor(codEmpresa?: number, serie?: number, numero?: number) {
    super();
    this.codEmpresa = codEmpresa || 0;
    this.serie = serie || 0;
    this.numero = numero || 0;
  }

  public getPK(): PKDocVendaAPP {
    return new PKDocVendaAPP(this.codEmpresa, this.serie, this.numero);
  }

  public equals(arg: PKDocVendaAPP): boolean {
    return arg 
        && (arg.serie === this.serie)
        && (arg.numero === this.numero)
        && (arg.codEmpresa === this.codEmpresa)
    ;
  }
}


export class DataVendaVitPub extends PKVendaVit {
  readonly jclass: string = "com.macle.vitrine.vo.DataVendaVitPub";
  data: string = "";
  hora: string = "";
  valor: number = 0;
  desconto: number = 0;
  codEmpresaVenda: number = 0;
  vendedor: PKVendedorAPP = new PKVendedorAPP();
  codVitrineVenda: number = 0;
  listItem: ArrayList<DataVendaItemVitPub> = new ArrayList<DataVendaItemVitPub>(DataVendaItemVitPub);
}


export class DataSendLiquidaParcelaAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataSendLiquidaParcelaAPP";
  dataEmissaoBoleto: string = "";
  formaPagamento: EFormaPagamentoAPP = EFormaPagamentoAPP.NONE;
  dataPagamento: string = "";
  listPkParc: ArrayList<PKParcelaAPP> = new ArrayList<PKParcelaAPP>(PKParcelaAPP);
  valorPago: number = 0;
  idPagamento: number = 0;
  idTransacao: number = 0;
}


export class DataFrenetCotacaoServicoResponseVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetCotacaoServicoResponseVit";
  error: boolean = false;
  services: DataFrenetCotacaoServicoVit = new DataFrenetCotacaoServicoVit();
  shippingPrice: number = 0;
  shippingServiceCode: string = "";
  shippingServiceName: string = "";
  msg: string = "";
  carrier: string = "";
  carrierCode: string = "";
  deliveryTime: number = 0;
  shippingCompetitorPrice: number = 0;
  platformShippingPrice: number = 0;
}


export class ConsLojaAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.ConsLojaAPP";
  cnpj: string = "";
  cidade: string = "";
  CEP: number = 0;
  UF: string = "";
  bairro: string = "";
  numero: string = "";
  codEmpresa: number = 0;
  logradouro: string = "";
  fantasia: string = "";
}


export class ConsLojasComVendedorAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.ConsLojasComVendedorAPP";
  listLoja: ArrayList<ConsLojaAPP> = new ArrayList<ConsLojaAPP>(ConsLojaAPP);
  listVendedor: ArrayList<ConsVendedorAPP> = new ArrayList<ConsVendedorAPP>(ConsVendedorAPP);
}


export enum ETipoPrecoVendaAPP {
  NONE = 0,
  PRCITEM = 1,
  PRCEMPRESA = 2,
  PRCTAMANHO = 3,
  PRCEMPTAM = 4,
}

export namespace ETipoPrecoVendaAPP {
  export function toDisplay(arg: ETipoPrecoVendaAPP): string {
    switch (arg) {
      case 0: return "";
      case 1: return "Pre&ccedil;o do item";
      case 2: return "Pre&ccedil;o por empresa";
      case 3: return "Pre&ccedil;o por tamanho";
      case 4: return "Prc.empresa e tamanho";
      default: return "";
    }
  }

  export function enums(): ETipoPrecoVendaAPP[] {
    return [ETipoPrecoVendaAPP.NONE,ETipoPrecoVendaAPP.PRCITEM,ETipoPrecoVendaAPP.PRCEMPRESA,ETipoPrecoVendaAPP.PRCTAMANHO,ETipoPrecoVendaAPP.PRCEMPTAM];
  }
}


export class DataFrenetPedidoEtiquetaItemVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetPedidoEtiquetaItemVit";
  length: number = 0;
  fragile: boolean = false;
  itemId: string = "";
  price: number = 0;
  orderId: string = "";
  sku: string = "";
  height: number = 0;
  weight: number = 0;
  width: number = 0;
  quantity: number = 0;
  productName: string = "";
  productOptions: string = "";
  productId: string = "";
  productType: string = "";
  category: string = "";
}


export class DataFrenetPedidoEtiquetaNotaVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetPedidoEtiquetaNotaVit";
  value: number = 0;
  key: string = "";
  number: string = "";
  date: string = "";
  series: string = "";
  CFOP: string = "";
}


export class DataFrenetPedidoEtiquetaOrdemVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetPedidoEtiquetaOrdemVit";
  value: number = 0;
  id: string = "";
  from: DataFrenetPedidoEtiquetaClienteVit = new DataFrenetPedidoEtiquetaClienteVit();
  created: string = "";
  to: DataFrenetPedidoEtiquetaClienteVit = new DataFrenetPedidoEtiquetaClienteVit();
  items: ArrayList<DataFrenetPedidoEtiquetaItemVit> = new ArrayList<DataFrenetPedidoEtiquetaItemVit>(DataFrenetPedidoEtiquetaItemVit);
  invoice: DataFrenetPedidoEtiquetaNotaVit = new DataFrenetPedidoEtiquetaNotaVit();
  useFrenetRegistration: boolean = false;
}


export class DataPedidoEnderecoVit extends PKPedidoVit {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoEnderecoVit";
  endereco: DataEndereco = new DataEndereco();
}


export class DataPedidoItemVitPub extends PKPedidoVit {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoItemVitPub";
  item: PKTamanhoItemAPP = new PKTamanhoItemAPP();
  qtd: number = 0;
  descricao: string = "";
  itemVit: PKItemLojaVitPub = new PKItemLojaVitPub();
  desconto: number = 0;
  precoUnitario: number = 0;
}


export class DataPedidoLojaPub extends PKPedidoVitPub {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoLojaPub";
  status: EStatusPedidoSite = EStatusPedidoSite.NONE;
  dataCancelamento: string = "";
  nroetiquetasigep: string = "";
  dataUltimoUpdate: string = "";
  horaUltimoUpdate: string = "";
}


export class DataPedidoVitPub extends PKPedidoVit {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoVitPub";
  data: string = "";
  hora: string = "";
  valor: number = 0;
  cliente: DataPedidoClienteVit = new DataPedidoClienteVit();
  formaPagamento: DataPedidoFormaPagamentoVit = new DataPedidoFormaPagamentoVit();
  enviadoSistema: boolean = false;
  desconto: number = 0;
  listEntrega: ArrayList<DataPedidoEntregaVitPub> = new ArrayList<DataPedidoEntregaVitPub>(DataPedidoEntregaVitPub);
  vendedor: PKVendedorAPP = new PKVendedorAPP();
  enderecoEntrega: DataPedidoEnderecoVit = new DataPedidoEnderecoVit();
  listItem: ArrayList<DataPedidoItemVitPub> = new ArrayList<DataPedidoItemVitPub>(DataPedidoItemVitPub);
  acrescimo: number = 0;
  listPedidoLoja: ArrayList<DataPedidoLojaPub> = new ArrayList<DataPedidoLojaPub>(DataPedidoLojaPub);
  codEmpresaPedido: number = 0;
}


export class DataRetirarLojaVitrinePubAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataRetirarLojaVitrinePubAPP";
  lojasComVendedor: ConsLojasComVendedorAPP = new ConsLojasComVendedorAPP();
  codClienteMacle: number = 0;
  fantasia: string = "";
}


export class ConsParcelaLiquidacaoAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.ConsParcelaLiquidacaoAPP";
  numeroTotalParcelas: number = 0;
  parcela: PKParcelaAPP = new PKParcelaAPP();
  vencida: boolean = false;
  saldo: number = 0;
  cliente: PKDependenteAPP = new PKDependenteAPP();
  documentoOrigem: string = "";
  dataEmissao: string = "";
  numeroParcela: number = 0;
  dataVencimento: string = "";
}


export class DataCepAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataCepAPP";
  codCEP: number = 0;
  codUF: string = "";
  cidade: string = "";
  bairro: string = "";
  logradouro: string = "";
}


export class ConsClienteAPP extends PKDependenteAPP {
  readonly jclass: string = "com.macle.app.vo.ConsClienteAPP";
  qtdParcAtivas: number = 0;
  regraMinimaAtiva: boolean = false;
  dadosResumidos: boolean = false;
  endereco: DataEndereco = new DataEndereco();
  clienteNovo: boolean = false;
  limiteCredito: number = 0;
  qtdItens: number = 0;
  telefone: string = "";
  qtdParcVencida: number = 0;
  dataNascimento: string = "";
  email: string = "";
  sexo: ESexo = ESexo.NONE;
  nome: string = "";
  cnpj: string = "";
  pontos: number = 0;
  crediarioLiberado: boolean = false;
  totalLimiteCredito: number = 0;
}


export class DataFrenetEtiquetaErroVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetEtiquetaErroVit";
  message: string = "";
  code: number = 0;
}


export class DataFrenetPedidoEtiquetaVolumeVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetPedidoEtiquetaVolumeVit";
  length: number = 0;
  price: number = 0;
  height: number = 0;
  weight: number = 0;
  width: number = 0;
  declaredValue: number = 0;
  volumeId: number = 0;
}


export class DataFrenetPedidoEtiquetaVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetPedidoEtiquetaVit";
  order: DataFrenetPedidoEtiquetaOrdemVit = new DataFrenetPedidoEtiquetaOrdemVit();
  volumes: DataFrenetPedidoEtiquetaVolumeVit = new DataFrenetPedidoEtiquetaVolumeVit();
  shipmentId: number = 0;
  shipmentStatus: number = 0;
  quotation: DataFrenetCotacaoServicoResponseVit = new DataFrenetCotacaoServicoResponseVit();
  branchCode: string = "";
  trackingNotificationUrl: string = "";
  statusNotificationUrl: string = "";
}


export class DataDocVendaItemAPP extends PKTamanhoItemAPP {
  readonly jclass: string = "com.macle.app.vo.DataDocVendaItemAPP";
  qtd: number = 0;
  descricao: string = "";
  descricaoTamanho: string = "";
  imagem: string = "";
}


export class DataDocVendaAPP extends PKDocVendaAPP {
  readonly jclass: string = "com.macle.app.vo.DataDocVendaAPP";
  itens: ArrayList<DataDocVendaItemAPP> = new ArrayList<DataDocVendaItemAPP>(DataDocVendaItemAPP);
  hora: string = "";
  dataEmissao: string = "";
}


export class PKZoopTransacaoAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.PKZoopTransacaoAPP";
  codZoopTransacao: number = 0;

  constructor()
  constructor(codZoopTransacao: number)
  constructor(codZoopTransacao?: number) {
    super();
    this.codZoopTransacao = codZoopTransacao || 0;
  }

  public getPK(): PKZoopTransacaoAPP {
    return new PKZoopTransacaoAPP(this.codZoopTransacao);
  }

  public equals(arg: PKZoopTransacaoAPP): boolean {
    return arg 
        && (arg.codZoopTransacao === this.codZoopTransacao)
    ;
  }
}


export class DataZoopTransacaoAPP extends PKZoopTransacaoAPP {
  readonly jclass: string = "com.macle.app.vo.DataZoopTransacaoAPP";
  data: string = "";
  hora: string = "";
  cliente: PKDependenteAPP = new PKDependenteAPP();
  idCobranca: string = "";
  idPedido: string = "";
  idTransacao: number = 0;
  jsonTransacao: string = "";
}


export class DataFreteVitrineServico extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFreteVitrineServico";
  nome: string = "";
  indisponivel: boolean = false;
  codigo: string = "";
  diasEntrega: number = 0;
  valorEntrega: number = 0;
}


export class DataFreteVitrineOperadora extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFreteVitrineOperadora";
  nome: string = "";
  codigo: string = "";
  servicos: ArrayList<DataFreteVitrineServico> = new ArrayList<DataFreteVitrineServico>(DataFreteVitrineServico);
}


export class DataSendLiquidaParcelaPagarmeV5APP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataSendLiquidaParcelaPagarmeV5APP";
  dataEmissaoBoleto: string = "";
  formaPagamento: EFormaPagamentoAPP = EFormaPagamentoAPP.NONE;
  dataPagamento: string = "";
  idCobranca: string = "";
  idPedido: string = "";
  listPkParc: ArrayList<PKParcelaAPP> = new ArrayList<PKParcelaAPP>(PKParcelaAPP);
  valorPago: number = 0;
}


export class PKPagamentoPIXAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.PKPagamentoPIXAPP";
  codPagamentoPIX: number = 0;

  constructor()
  constructor(codPagamentoPIX: number)
  constructor(codPagamentoPIX?: number) {
    super();
    this.codPagamentoPIX = codPagamentoPIX || 0;
  }

  public getPK(): PKPagamentoPIXAPP {
    return new PKPagamentoPIXAPP(this.codPagamentoPIX);
  }

  public equals(arg: PKPagamentoPIXAPP): boolean {
    return arg 
        && (arg.codPagamentoPIX === this.codPagamentoPIX)
    ;
  }
}


export class DataPagamentoPIXAPP extends PKPagamentoPIXAPP {
  readonly jclass: string = "com.macle.app.vo.DataPagamentoPIXAPP";
  dataHoraValidoAte: string = "";
  liquidacaoParcela: PKLiquidacaoParcelaAPP = new PKLiquidacaoParcelaAPP();
  transactionId: string = "";
  idCobranca: string = "";
  idPedido: string = "";
  codEmpresa: number = 0;
  conta: PKContaAPP = new PKContaAPP();
  venda: PKVendaAPP = new PKVendaAPP();
  pago: boolean = false;
}


export class DataFrenetCotacaoResponseVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetCotacaoResponseVit";
  shippingServiceCodeSelect: string = "";
  sessionId: string = "";
  quotations: ArrayList<DataFrenetCotacaoServicoResponseVit> = new ArrayList<DataFrenetCotacaoServicoResponseVit>(DataFrenetCotacaoServicoResponseVit);
}


export class DataVendaEntregaAPP extends PKVendaAPP {
  readonly jclass: string = "com.macle.app.vo.DataVendaEntregaAPP";
  codClienteMacle: PKClienteMacleVitPub = new PKClienteMacleVitPub();
  frete: DataFreteAPP = new DataFreteAPP();
  cotacaoFrenet: DataFrenetCotacaoResponseVit = new DataFrenetCotacaoResponseVit();
  taxaEntrega: number = 0;
  retiradaLoja: boolean = false;
  distancia: DataEntregaDistanciaAPP = new DataEntregaDistanciaAPP();
  codEmpresaRetiradaLoja: number = 0;
}


export class DataFrenetPedidoEtiquetaItemResponseVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetPedidoEtiquetaItemResponseVit";
  errors: ArrayList<DataFrenetEtiquetaErroVit> = new ArrayList<DataFrenetEtiquetaErroVit>(DataFrenetEtiquetaErroVit);
  orderId: string = "";
  shipmentId: number = 0;
  shipmentStatus: number = 0;
  trackingUrl: string = "";
  labelUrl: string = "";
  declarationUrl: string = "";
  validThrough: string = "";
  receiptNotificationUrl: string = "";
}


export class DataSendStatusPedido extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataSendStatusPedido";
  status: EStatusPedidoSite = EStatusPedidoSite.NONE;
  venda: PKPedidoVit = new PKPedidoVit();
}


export class DataPrecoVendaAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataPrecoVendaAPP";
  item: PKTamanhoItemAPP = new PKTamanhoItemAPP();
  promocao: boolean = false;
  congelado: boolean = false;
  precoVenda: number = 0;
  codEmpresa: number = 0;
  dataIniPromo: string = "";
  dataAlter: string = "";
  precoAlter: number = 0;
  dataFimPromo: string = "";
  vlrPromo: number = 0;
}


export class DataResultEmiteBoletoZoopAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataResultEmiteBoletoZoopAPP";
  vencimentoBoleto: string = "";
  valorBoletoSemTaxa: number = 0;
  urlBoleto: string = "";
  barcodeBoleto: string = "";
  valorBoleto: number = 0;
  pkTransacao: PKZoopTransacaoAPP = new PKZoopTransacaoAPP();
}


export class DataPedidoAntFraudeVit extends PKPedidoVit {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoAntFraudeVit";
  ip: string = "";
  koinSessionID: string = "";
}


export class DataEntregaLojaVitrinePubAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataEntregaLojaVitrinePubAPP";
  codClienteMacle: number = 0;
  distanciaKM: number = 0;
  nomeLoja: string = "";
  valorTaxaEntregaCompraAPP: number = 0;
  distanciaMaximaEntregaCompraAPP: number = 0;
  distanciaEntregaGratisCompraAPP: number = 0;
}


export class ConsumidorSiteResponseChaveConfirmacaoValida extends BaseData {
  readonly jclass: string = "com.macle.app.vo.ConsumidorSiteResponseChaveConfirmacaoValida";
  chaveConfirmacaoValida: boolean = false;
  token: string = "";
  pkCliente: PKDependenteAPP = new PKDependenteAPP();
}


export class DataUrlParametrosAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataUrlParametrosAPP";
  itens: string[] = [];
  codVitrine: number = 0;
  codVendedor: number = 0;
  codEmpVendedor: number = 0;
  codEmpresaVenda: number = 0;
}


export class DataDadosClienteEmissaoBoletoAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataDadosClienteEmissaoBoletoAPP";
  endereco: string = "";
  telefone: string = "";
  email: string = "";
  nome: string = "";
  enderecoCidade: string = "";
  enderecoBairro: string = "";
  enderecoEstado: string = "";
  numeroDocumento: string = "";
  enderecoNumero: string = "";
  enderecoCEP: string = "";
  telefoneDDD: string = "";
}


export class FilterLiquidacaoAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.FilterLiquidacaoAPP";
}


export enum EStatusPedidoML {
  NONE = 0,
  confirmed = 1,
  payment_required = 2,
  payment_in_process = 3,
  partially_paid = 4,
  paid = 5,
  partially_refunded = 6,
  pending_cancel = 7,
  cancelled = 8,
  invalid = 9,
}

export namespace EStatusPedidoML {
  export function toDisplay(arg: EStatusPedidoML): string {
    switch (arg) {
      case 0: return "";
      case 1: return "Status inicial de uma order; ainda sem ter sido paga.";
      case 2: return "O pagamento da order deve ter sido confirmado para exibir as informa&ccedil;&otilde;es do usu&aacute;rio.";
      case 3: return "H&aacute; um pagamento relacionado à order, mais ainda n&atilde;o foi aprovado.";
      case 4: return "A order tem um pagamento associado creditado, por&eacute;m, insuficiente.";
      case 5: return "A order tem um pagamento associado aprovado.";
      case 6: return "A order tem devolu&ccedil;&otilde;es paciais de seus pagamentos.";
      case 7: return "Quando a order foi cancelada mas temos dificultdade para devolver o pagamento.";
      case 8: return "Por alguma raz&atilde;o, a order n&atilde;o foi completada.";
      case 9: return "A order foi invalidada por vir de um comprador malicioso.";
      default: return "";
    }
  }

  export function enums(): EStatusPedidoML[] {
    return [EStatusPedidoML.NONE,EStatusPedidoML.confirmed,EStatusPedidoML.payment_required,EStatusPedidoML.payment_in_process,EStatusPedidoML.partially_paid,EStatusPedidoML.paid,EStatusPedidoML.partially_refunded,EStatusPedidoML.pending_cancel,EStatusPedidoML.cancelled,EStatusPedidoML.invalid];
  }
}


export class DataParametrosVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataParametrosVit";
  pixelID: string = "";
  gtmID: string = "";
  habilitaGTM: boolean = false;
  habilitaPixel: boolean = false;
  googleAnalytics: string = "";
  googleVerificacao: string = "";

  constructor()
  constructor(habilitaPixel: boolean, pixelID: string, habilitaGTM: boolean, gtmID: string, googleVerificacao: string, googleAnalytics: string)
  constructor(habilitaPixel?: boolean, pixelID?: string, habilitaGTM?: boolean, gtmID?: string, googleVerificacao?: string, googleAnalytics?: string) {
    super();
    this.habilitaPixel = habilitaPixel || false;
    this.pixelID = pixelID || "";
    this.habilitaGTM = habilitaGTM || false;
    this.gtmID = gtmID || "";
    this.googleVerificacao = googleVerificacao || "";
    this.googleAnalytics = googleAnalytics || "";
  }

  public getPK(): DataParametrosVit {
    return new DataParametrosVit(this.habilitaPixel, this.pixelID, this.habilitaGTM, this.gtmID, this.googleVerificacao, this.googleAnalytics);
  }

  public equals(arg: DataParametrosVit): boolean {
    return arg 
        && (arg.pixelID === this.pixelID)
        && (arg.gtmID === this.gtmID)
        && (arg.habilitaGTM === this.habilitaGTM)
        && (arg.habilitaPixel === this.habilitaPixel)
        && (arg.googleAnalytics === this.googleAnalytics)
        && (arg.googleVerificacao === this.googleVerificacao)
    ;
  }
}


export class PKPagamentoParcelaAPP extends PKLiquidacaoParcelaAPP {
  readonly jclass: string = "com.macle.app.vo.PKPagamentoParcelaAPP";
  id: number = 0;
  idPagarmeV5: string = "";

  constructor()
  constructor(codLiquidacaoParcela: number, id: number, idPagarmeV5: string)
  constructor(codLiquidacaoParcela?: number, id?: number, idPagarmeV5?: string) {
    super();
    this.codLiquidacaoParcela = codLiquidacaoParcela || 0;
    this.id = id || 0;
    this.idPagarmeV5 = idPagarmeV5 || "";
  }

  public getPK(): PKPagamentoParcelaAPP {
    return new PKPagamentoParcelaAPP(this.codLiquidacaoParcela, this.id, this.idPagarmeV5);
  }

  public equals(arg: PKPagamentoParcelaAPP): boolean {
    return arg && super.equals(arg)
        && (arg.id === this.id)
        && (arg.idPagarmeV5 === this.idPagarmeV5)
    ;
  }
}


export class DataVendaFormaPagamentoAPP extends PKVendaAPP {
  readonly jclass: string = "com.macle.app.vo.DataVendaFormaPagamentoAPP";
  formaPagamento: EFormaPagamentoAPP = EFormaPagamentoAPP.NONE;
  cartao: DataResultEmiteCartaoPedido = new DataResultEmiteCartaoPedido();
  pix: DataResultEmitePixPedido = new DataResultEmitePixPedido();
  codMaclePagto: number = 0;
  condVenda: PKCondVendaAPP = new PKCondVendaAPP();
}


export class ConsumidorSiteResponseGetConsumidorV1APP extends ConsumidorSiteResponseGetConsumidorV0APP {
  readonly jclass: string = "com.macle.app.vo.ConsumidorSiteResponseGetConsumidorV1APP";
  acessoAppPagtoParc: boolean = false;
}


export class ConsCondVendaAPP extends PKCondVendaAPP {
  readonly jclass: string = "com.macle.app.vo.ConsCondVendaAPP";
  descricao: string = "";
  diaEntreParc: number = 0;
  numParcelas: number = 0;
  pctAcres: number = 0;
  diaPrimeiraParc: number = 0;
  pctDesc: number = 0;
  forceVlrParc: number = 0;
  dataPrimParc: string = "";
  trintaDiasDireto: boolean = false;
  arredond: EArredondPrc = EArredondPrc.NONE;
  diaVencto: number = 0;
  pctEntrada: number = 0;
}


export class ConsCondVendaAuxAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.ConsCondVendaAuxAPP";
  listCondVenda: ArrayList<ConsCondVendaAPP> = new ArrayList<ConsCondVendaAPP>(ConsCondVendaAPP);
}


export class ConsCorItemAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.ConsCorItemAPP";
  nome: string = "";
  imagem: string = "";
  codItem: number = 0;
  codEmpItem: number = 0;

  constructor()
  constructor(codEmpItem: number, codItem: number, nome: string, imagem: string)
  constructor(codEmpItem?: number, codItem?: number, nome?: string, imagem?: string) {
    super();
    this.codEmpItem = codEmpItem || 0;
    this.codItem = codItem || 0;
    this.nome = nome || "";
    this.imagem = imagem || "";
  }

  public getPK(): ConsCorItemAPP {
    return new ConsCorItemAPP(this.codEmpItem, this.codItem, this.nome, this.imagem);
  }

  public equals(arg: ConsCorItemAPP): boolean {
    return arg 
        && (arg.nome === this.nome)
        && (arg.imagem === this.imagem)
        && (arg.codItem === this.codItem)
        && (arg.codEmpItem === this.codEmpItem)
    ;
  }
}


export class DataEmiteBoletoPagarMeAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataEmiteBoletoPagarMeAPP";
  valor: number = 0;
  dadosResumidos: boolean = false;
  endereco: string = "";
  telefone: string = "";
  email: string = "";
  nome: string = "";
  cliente: PKDependenteAPP = new PKDependenteAPP();
  enderecoCidade: string = "";
  enderecoBairro: string = "";
  enderecoEstado: string = "";
  numeroDocumento: string = "";
  liquidacao: DataLiquidacaoParcelaAPP = new DataLiquidacaoParcelaAPP();
  enderecoNumero: string = "";
  enderecoCEP: string = "";
  telefoneDDD: string = "";
}


export class DataFrenetPedidoEtiquetaErroVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetPedidoEtiquetaErroVit";
  message: string = "";
  details: ArrayList<DataFrenetEtiquetaErroVit> = new ArrayList<DataFrenetEtiquetaErroVit>(DataFrenetEtiquetaErroVit);
}


export class DataFrenetPedidoEtiquetaResponseVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetPedidoEtiquetaResponseVit";
  error: DataFrenetPedidoEtiquetaErroVit = new DataFrenetPedidoEtiquetaErroVit();
  items: ArrayList<DataFrenetPedidoEtiquetaItemResponseVit> = new ArrayList<DataFrenetPedidoEtiquetaItemResponseVit>(DataFrenetPedidoEtiquetaItemResponseVit);
  statusBatch: string = "";
}


export class ConsTamanhoItemAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.ConsTamanhoItemAPP";
  descricao: string = "";
  codTamanho: number = 0;
  disponivel: boolean = false;

  constructor()
  constructor(codTamanho: number, descricao: string, disponivel: boolean)
  constructor(codTamanho?: number, descricao?: string, disponivel?: boolean) {
    super();
    this.codTamanho = codTamanho || 0;
    this.descricao = descricao || "";
    this.disponivel = disponivel || false;
  }

  public getPK(): ConsTamanhoItemAPP {
    return new ConsTamanhoItemAPP(this.codTamanho, this.descricao, this.disponivel);
  }

  public equals(arg: ConsTamanhoItemAPP): boolean {
    return arg 
        && (arg.descricao === this.descricao)
        && (arg.codTamanho === this.codTamanho)
        && (arg.disponivel === this.disponivel)
    ;
  }
}


export class ConsItemAPP extends LVPKItem {
  readonly jclass: string = "com.macle.app.vo.ConsItemAPP";
  descricao: string = "";
  tipo: string = "";
  preco: number = 0;
  precos: ArrayList<DataPrecoVendaAPP> = new ArrayList<DataPrecoVendaAPP>(DataPrecoVendaAPP);
  cores: ArrayList<ConsCorItemAPP> = new ArrayList<ConsCorItemAPP>(ConsCorItemAPP);
  itemVit: PKItemLojaVitPub = new PKItemLojaVitPub();
  promocao: boolean = false;
  marca: string = "";
  imagens: string[] = [];
  refFornecedor: string = "";
  tamanhos: ArrayList<ConsTamanhoItemAPP> = new ArrayList<ConsTamanhoItemAPP>(ConsTamanhoItemAPP);
  precoTabela: number = 0;
  tipoPreco: ETipoPrecoVendaAPP = ETipoPrecoVendaAPP.NONE;
}


export class DataSendLiquidaParcelaZoopAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataSendLiquidaParcelaZoopAPP";
  dataEmissaoBoleto: string = "";
  formaPagamento: EFormaPagamentoAPP = EFormaPagamentoAPP.NONE;
  dataPagamento: string = "";
  codEmpresa: number = 0;
  conta: PKContaAPP = new PKContaAPP();
  transactionID: string = "";
  horaPagamento: string = "";
  listPkParc: ArrayList<PKParcelaAPP> = new ArrayList<PKParcelaAPP>(PKParcelaAPP);
  valorPago: number = 0;
  idTransacaoPIX: string = "";
}


export class DataFreteVitrine extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFreteVitrine";
  codigo: string = "";
  operadoras: ArrayList<DataFreteVitrineOperadora> = new ArrayList<DataFreteVitrineOperadora>(DataFreteVitrineOperadora);
}


export class DataEmiteBoletoVendaPagarMeAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataEmiteBoletoVendaPagarMeAPP";
  valor: number = 0;
  dadosResumidos: boolean = false;
  endereco: string = "";
  telefone: string = "";
  email: string = "";
  nome: string = "";
  cliente: PKDependenteAPP = new PKDependenteAPP();
  vendaVitrinePub: DataVendaVitrinePublicaAPP = new DataVendaVitrinePublicaAPP();
  enderecoCidade: string = "";
  enderecoBairro: string = "";
  enderecoEstado: string = "";
  numeroDocumento: string = "";
  enderecoNumero: string = "";
  listProduto: ArrayList<DataVendaItemAPP> = new ArrayList<DataVendaItemAPP>(DataVendaItemAPP);
  enderecoCEP: string = "";
  telefoneDDD: string = "";
}


export class DataCanSelectParcelaApp extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataCanSelectParcelaApp";
  parcela: PKParcelaAPP = new PKParcelaAPP();
  marcadas: ArrayList<PKParcelaAPP> = new ArrayList<PKParcelaAPP>(PKParcelaAPP);
}


export class DataPagamentoParcelaAPP extends PKPagamentoParcelaAPP {
  readonly jclass: string = "com.macle.app.vo.DataPagamentoParcelaAPP";
  valor: number = 0;
  dataCriacao: string = "";
  dataPagamento: string = "";
}


export class DataFrenetShippingResponseVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetShippingResponseVit";
  shippingSevicesArray: ArrayList<DataFrenetShippingServiceResponseVit> = new ArrayList<DataFrenetShippingServiceResponseVit>(DataFrenetShippingServiceResponseVit);
}


export class DataTipoItemVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataTipoItemVit";
  codigoTipo: number = 0;
  descricaoTipo: string = "";
}


export class DataRespCanSelect extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataRespCanSelect";
  canSelectText: string = "";
  canSelect: boolean = false;
}


export class DataVendaClienteAPP extends PKVendaAPP {
  readonly jclass: string = "com.macle.app.vo.DataVendaClienteAPP";
  telefone: string = "";
  dataNascimento: string = "";
  email: string = "";
  sexo: ESexo = ESexo.NONE;
  nome: string = "";
  cnpj: string = "";
  cliente: PKDependenteAPP = new PKDependenteAPP();
  inscEstadual: string = "";
  dadosResumido: boolean = false;
}


export class DataVendaAPP extends PKVendaAPP {
  readonly jclass: string = "com.macle.app.vo.DataVendaAPP";
  data: string = "";
  hora: string = "";
  valor: number = 0;
  cliente: DataVendaClienteAPP = new DataVendaClienteAPP();
  formaPagamento: DataVendaFormaPagamentoAPP = new DataVendaFormaPagamentoAPP();
  enviadoSistema: boolean = false;
  status: EStatusPedidoSite = EStatusPedidoSite.NONE;
  enviadoVitrine: boolean = false;
  desconto: number = 0;
  pkVendaVit: PKVendaVit = new PKVendaVit();
  codEmpresaVenda: number = 0;
  listEntrega: ArrayList<DataVendaEntregaAPP> = new ArrayList<DataVendaEntregaAPP>(DataVendaEntregaAPP);
  vendedor: PKVendedorAPP = new PKVendedorAPP();
  enderecoEntrega: DataVendaEnderecoAPP = new DataVendaEnderecoAPP();
  idPedidoML: number = 0;
  vendaFinalizada: boolean = false;
  codVitrineVenda: number = 0;
  listItem: ArrayList<DataVendaItemAPP> = new ArrayList<DataVendaItemAPP>(DataVendaItemAPP);
  idPedidoEntregaML: number = 0;
}


export class ConsItemVitEstoque extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.ConsItemVitEstoque";
  qtd: number = 0;
  descricao: string = "";
  codTamanho: number = 0;
  ordem: number = 0;

  constructor()
  constructor(codTamanho: number, descricao: string, ordem: number, qtd: number)
  constructor(codTamanho?: number, descricao?: string, ordem?: number, qtd?: number) {
    super();
    this.codTamanho = codTamanho || 0;
    this.descricao = descricao || "";
    this.ordem = ordem || 0;
    this.qtd = qtd || 0;
  }

  public getPK(): ConsItemVitEstoque {
    return new ConsItemVitEstoque(this.codTamanho, this.descricao, this.ordem, this.qtd);
  }

  public equals(arg: ConsItemVitEstoque): boolean {
    return arg 
        && (arg.qtd === this.qtd)
        && (arg.descricao === this.descricao)
        && (arg.codTamanho === this.codTamanho)
        && (arg.ordem === this.ordem)
    ;
  }
}


export class DataResultEmitePixZoopAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataResultEmitePixZoopAPP";
  dataHoraValidade: string = "";
  qr_code: string = "";
  qr_code_url: string = "";
  pkLiquidacao: PKLiquidacaoParcelaAPP = new PKLiquidacaoParcelaAPP();
  valorPIX: number = 0;
}


export class DataMedidaItemVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataMedidaItemVit";
  pesoGramas: number = 0;
  larguraCM: number = 0;
  comprimentoCM: number = 0;
  alturaCM: number = 0;
}


export class DataPedidoVit extends PKPedidoVit {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoVit";
  data: string = "";
  hora: string = "";
  valor: number = 0;
  cliente: DataPedidoClienteVit = new DataPedidoClienteVit();
  formaPagamento: DataPedidoFormaPagamentoVit = new DataPedidoFormaPagamentoVit();
  enviadoSistema: boolean = false;
  status: EStatusPedidoSite = EStatusPedidoSite.NONE;
  cotacaoFrenet: DataFrenetCotacaoResponseVit = new DataFrenetCotacaoResponseVit();
  desconto: number = 0;
  vendedor: PKVendedorAPP = new PKVendedorAPP();
  enderecoEntrega: DataPedidoEnderecoVit = new DataPedidoEnderecoVit();
  idPedidoML: number = 0;
  listItem: ArrayList<DataPedidoItemVit> = new ArrayList<DataPedidoItemVit>(DataPedidoItemVit);
  entrega: DataPedidoEntregaVit = new DataPedidoEntregaVit();
  antiFraude: DataPedidoAntFraudeVit = new DataPedidoAntFraudeVit();
  acrescimo: number = 0;
  cupomDesconto: ArrayList<DataPedidoCupomDesconto> = new ArrayList<DataPedidoCupomDesconto>(DataPedidoCupomDesconto);
  pedidoML: DataPedidoResultML = new DataPedidoResultML();
  dataCancelamento: string = "";
  nroetiquetasigep: string = "";
  dataUltimoUpdate: string = "";
  codEmpresaPedido: number = 0;
  horaUltimoUpdate: string = "";
}


export class DataFrenetShippingItemVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetShippingItemVit";
  length: number = 0;
  SKU: string = "";
  height: number = 0;
  weight: number = 0;
  width: number = 0;
  quantity: number = 0;
  category: string = "";
}


export class DataFrenetShippingVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetShippingVit";
  shippingServiceCode: string = "";
  sellerCEP: string = "";
  recipientCEP: string = "";
  shipmentInvoiceValue: number = 0;
  shippingItemArray: ArrayList<DataFrenetShippingItemVit> = new ArrayList<DataFrenetShippingItemVit>(DataFrenetShippingItemVit);
  recipientCountry: string = "";
}


export class DataShareAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataShareAPP";
  itens: ArrayList<DataShareItemAPP> = new ArrayList<DataShareItemAPP>(DataShareItemAPP);
  url: string = "";
}


export enum EStatusProdutoML {
  NONE = 0,
  active = 1,
  closed = 2,
  paused = 3,
  under_review = 4,
}

export namespace EStatusProdutoML {
  export function toDisplay(arg: EStatusProdutoML): string {
    switch (arg) {
      case 0: return "";
      case 1: return "Ativo";
      case 2: return "Inativo";
      case 3: return "Pausado";
      case 4: return "Em revis&atilde;o";
      default: return "";
    }
  }

  export function enums(): EStatusProdutoML[] {
    return [EStatusProdutoML.NONE,EStatusProdutoML.active,EStatusProdutoML.closed,EStatusProdutoML.paused,EStatusProdutoML.under_review];
  }
}


export class PKItemHashtagVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.PKItemHashtagVit";
  codHashtag: number = 0;

  constructor()
  constructor(codHashtag: number)
  constructor(codHashtag?: number) {
    super();
    this.codHashtag = codHashtag || 0;
  }

  public getPK(): PKItemHashtagVit {
    return new PKItemHashtagVit(this.codHashtag);
  }

  public equals(arg: PKItemHashtagVit): boolean {
    return arg 
        && (arg.codHashtag === this.codHashtag)
    ;
  }
}


export class DataConsultaParcelaAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataConsultaParcelaAPP";
  cliente: PKDependenteAPP = new PKDependenteAPP();
  listBoletos: ArrayList<DataLiquidacaoParcelaAPP> = new ArrayList<DataLiquidacaoParcelaAPP>(DataLiquidacaoParcelaAPP);
  dadosCliente: DataDadosClienteEmissaoBoletoAPP = new DataDadosClienteEmissaoBoletoAPP();
  listParcelas: ArrayList<ConsParcelaLiquidacaoAPP> = new ArrayList<ConsParcelaLiquidacaoAPP>(ConsParcelaLiquidacaoAPP);
}


export class DataItemHashTagVit extends PKItemHashtagVit {
  readonly jclass: string = "com.macle.vitrine.vo.DataItemHashTagVit";
  hashtag: string = "";
}


